import { render, staticRenderFns } from "./DashboardAppointments.vue?vue&type=template&id=8981cdac&scoped=true"
import script from "./DashboardAppointments.vue?vue&type=script&lang=js"
export * from "./DashboardAppointments.vue?vue&type=script&lang=js"
import style0 from "./DashboardAppointments.vue?vue&type=style&index=0&id=8981cdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8981cdac",
  null
  
)

export default component.exports